export default __webpack_public_path__ + "static/media/AdobeStock_134251559-1-scaled.4df043f7.jpg";